import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseButtonComponent } from '../base/base-button.component';
import { ButtonType, PrimeButtonStyle, ButtonSize, PrimeNGButtonStyle } from '../base/button.properties';
import { BadgeType } from '@shared/utils/evidence-management';

@Component({
  selector: 'shared-ui-buttons-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
  standalone: false,
})
export class ButtonComponent extends BaseButtonComponent implements OnInit {
  @Input() iconTooltip = '';
  @Input() badgeText?: string;
  @Input() badgeType?: BadgeType;
  @Input() textAfterBadge = '';
  @Input() showSpinner = false;
  @Output() action: EventEmitter<void> = new EventEmitter();
  @Input() styleClass?: string;

  buttonType = ButtonType;

  constructor() {
    super();
  }

  ngOnInit(): void {}

  public buttonClicked(): void {
    this.action.emit();
  }

  get primeButtonStyle(): PrimeNGButtonStyle {
    return PrimeButtonStyle[this.type];
  }

  get sizeClass(): ButtonSize {
    return this.size;
  }
}
